import { createStructuredSelector } from 'reselect'

import {
  EVALUATION_LIST,
  EVALUATION_LIST_SUCCESS, 
  EVALUATION_LIST_ERROR,
  EVALUATION_PAGE_SET,
  EVALUATION_SEARCH_SET,
  EVALUATION_SEARCH_CHANGE,
  EVALUATION_SEARCH_ASSESSMENT,
  EVALUATION_SEARCH_ASSESSMENT_SUCCESS,
  EVALUATION_SEARCH_ASSESSMENT_ERROR, 
  EVALUATION_SEARCH_ASSESSMENT_PROJECT,
  EVALUATION_SEARCH_ASSESSMENT_PROJECT_SUCCESS,
  EVALUATION_SEARCH_ASSESSMENT_PROJECT_ERROR, 
  EVALUATION_SEARCH_SUPERVISION_REPORT,
  EVALUATION_SEARCH_SUPERVISION_REPORT_SUCCESS,
  EVALUATION_SEARCH_SUPERVISION_REPORT_ERROR, 
  EVALUATION_ADD_SET,
  EVALUATION_ADD_MODAL_SET,
  EVALUATION_ADD,
  EVALUATION_ADD_SUCCESS,
  EVALUATION_ADD_ERROR,
  EVALUATION_ADD_CHANGE,
  EVALUATION_DETAIL,
  EVALUATION_DETAIL_SUCCESS,
  EVALUATION_DETAIL_ERROR,
  EVALUATION_GET,
  EVALUATION_GET_SUCCESS,
  EVALUATION_GET_ERROR,
  EVALUATION_VIEW_MODAL_SET,
  EVALUATION_EDIT_CHANGE,
  EVALUATION_EDIT_MODAL_SET,
  EVALUATION_UPDATE,
  EVALUATION_UPDATE_SUCCESS,
  EVALUATION_UPDATE_ERROR,
  EVALUATION_VIEW_TAB_SET,
  EVALUATION_UPLOAD_SET,
  EVALUATION_UPLOAD_SET_SUCCESS,
  EVALUATION_UPLOAD_SET_ERROR,
  EVALUATION_UPLOAD_RESET
} from '../../actions';

export const NAME = 'evaluation';

export const EvaluationList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type: EVALUATION_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const EvaluationListSuccess = (data) => ({
  type: EVALUATION_LIST_SUCCESS,
  payload: data
});

export const EvaluationListError = (error) => ({
  type: EVALUATION_LIST_ERROR,
  payload: error
});

export const EvaluationPageSet = (data) => ({
  type: EVALUATION_PAGE_SET,
  payload: data
});

export const EvaluationSearchSet = (data) => ({
  type: EVALUATION_SEARCH_SET,
  payload: data
});

export const EvaluationSearchChangeSet = (data) => ({
  type: EVALUATION_SEARCH_CHANGE,
  payload: data
});

export const EvaluationSearchAssessment = (data) => ({
  type: EVALUATION_SEARCH_ASSESSMENT,
  payload: data
});

export const EvaluationSearchAssessmentSuccess = (message) => ({
  type: EVALUATION_SEARCH_ASSESSMENT_SUCCESS,
  payload: message
});

export const EvaluationSearchAssessmentError = (error) => ({
  type: EVALUATION_SEARCH_ASSESSMENT_ERROR,
  payload: error
}); 

export const EvaluationSearchAssessmentProject = (data) => ({
  type: EVALUATION_SEARCH_ASSESSMENT_PROJECT,
  payload: data
});

export const EvaluationSearchAssessmentProjectSuccess = (message) => ({
  type: EVALUATION_SEARCH_ASSESSMENT_PROJECT_SUCCESS,
  payload: message
});

export const EvaluationSearchAssessmentProjectError = (error) => ({
  type: EVALUATION_SEARCH_ASSESSMENT_PROJECT_ERROR,
  payload: error
}); 

export const EvaluationSearchSupervisionReport = (data) => ({
  type: EVALUATION_SEARCH_SUPERVISION_REPORT,
  payload: data
});

export const EvaluationSearchSupervisionReportSuccess = (message) => ({
  type: EVALUATION_SEARCH_SUPERVISION_REPORT_SUCCESS,
  payload: message
});

export const EvaluationSearchSupervisionReportError = (error) => ({
  type: EVALUATION_SEARCH_SUPERVISION_REPORT_ERROR,
  payload: error
}); 

export const EvaluationAddChangeSet = (data) => ({
  type: EVALUATION_ADD_CHANGE,
  payload: data
});

export const EvaluationAddSet = (data) => ({
  type: EVALUATION_ADD_SET,
  payload: data
});

export const EvaluationAddModalSet = (data) => ({
  type: EVALUATION_ADD_MODAL_SET,
  payload: data
});

export const EvaluationAdd = (data) => ({
  type: EVALUATION_ADD,
  payload: data
});

export const EvaluationAddSuccess = (message) => ({
  type: EVALUATION_ADD_SUCCESS,
  payload: message
});

export const EvaluationAddError = (error) => ({
  type: EVALUATION_ADD_ERROR,
  payload: error
});


export const EvaluationGet = (data) => ({
  type: EVALUATION_GET,
  payload: data
});

export const EvaluationGetSuccess = (data) => ({
  type: EVALUATION_GET_SUCCESS,
  payload: data
});

export const EvaluationGetError = (error) => ({
  type: EVALUATION_GET_ERROR,
  payload: error
});

export const EvaluationDetail = (data) => ({
  type: EVALUATION_DETAIL,
  payload: data
});

export const EvaluationDetailSuccess = (data) => ({
  type: EVALUATION_DETAIL_SUCCESS,
  payload: data
});

export const EvaluationDetailError = (error) => ({
  type: EVALUATION_DETAIL_ERROR,
  payload: error
});
export const EvaluationViewModalSet = (data) => ({
  type: EVALUATION_VIEW_MODAL_SET,
  payload: data
});

export const EvaluationEditModalSet = (data) => ({
  type: EVALUATION_EDIT_MODAL_SET,
  payload: data
});

export const EvaluationEditChangeSet = (data) => ({
  type: EVALUATION_EDIT_CHANGE,
  payload: data
});

export const EvaluationUpdate = (data) => ({
  type: EVALUATION_UPDATE,
  payload: data
});

export const EvaluationUpdateSuccess = (message) => ({
  type: EVALUATION_UPDATE_SUCCESS,
  payload: message.message
});

export const EvaluationUpdateError = (error) => ({
  type: EVALUATION_UPDATE_ERROR,
  payload: error
});

export const EvaluationViewTabSet = (data) => ({
  type: EVALUATION_VIEW_TAB_SET,
  payload: data
});

export const EvaluationUploadSet = (file) => ({
  type: EVALUATION_UPLOAD_SET,
  payload: { file },
});

export const EvaluationUploadSetSuccess = (items) => ({
  type: EVALUATION_UPLOAD_SET_SUCCESS,
  payload: items,
});

export const EvaluationUploadSetError = (error) => ({
  type: EVALUATION_UPLOAD_SET_ERROR,
  payload: error,
});

export const EvaluationUploadReset= () => ({
  type: EVALUATION_UPLOAD_RESET
});

const evaluation = (state) => state[NAME];

export const EvaluationSelector = createStructuredSelector({
  evaluation
})
 